import { useTranslation } from 'next-i18next'

export default function SoldBy({}: any) {
  const { t: translate } = useTranslation('common')

  return (
    <div className="bg-brand text-white text-sm pl-6 py-2">
      {translate('text-sold-by', { ns: 'common' })}:{' '}
      <span className="underline">
        {translate('text-website-name', { ns: 'common' })}
      </span>
    </div>
  )
}
